import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Button, Grid, Typography, Box } from "@mui/material";
import "./HomePage.css";
import Header from "../../components/Header/Header";
import PromoVideo from '../../components/PromoVideo/PromoVideo';

const navLinks = [];

function HomePage() {
  const navigate = useNavigate();
  const { role } = useContext(AuthContext);

  const skipTrial = () => {
    if (role === 'school') {
      navigate('/setup-profile');
    } else {
      navigate("/purchase-plan");
    }
  };

  return (
    <>
      <Header navLinks={navLinks} isScrollEffect={false} />

      <Box className="page-container">
        <Box className="text-content">
          <Typography variant="h3" className="intro-title" gutterBottom>
            Welcome to Artificial Intelligence Mentor
          </Typography>

          <Typography variant="h6" className="intro-subtitle" gutterBottom>
            The Future of Interactive Learning Awaits You
          </Typography>

          <Typography variant="body1" className="intro-description" paragraph>
            AIM empowers educators, students, and institutions with advanced AI tools to revolutionize the way knowledge is shared and assessed.
            With our free trial, you can experience the full potential of AIM by creating two Assessments: upload a PDF containing your questions, or manually create them on the platform.
            Test the logic of our system by taking these Assessments yourself, just as your students would. It’s a hands-on way to explore our intuitive, powerful tools before committing to a paid plan.
          </Typography>

          <Typography variant="h6" className="call-to-action" gutterBottom>
            Ready to dive in? Start your free trial or proceed directly to setting up your account.
          </Typography>

          <Grid container spacing={2} className="actions-container">
            <Grid item>
              <Button
                className="primary-button"
                onClick={() => navigate("/free-trial")}
                variant="contained"
                size="large"
              >
                Start Free Trial
              </Button>
            </Grid>
            <Grid item>
              <Button
                className="secondary-button"
                onClick={skipTrial}
                variant="outlined"
                size="large"
              >
                Skip Trial & Register
              </Button>
            </Grid>
          </Grid>
        </Box>

        {/* Promo Video */}
        <PromoVideo title="Explore Our Platform in Action" />
      </Box>
    </>
  );
}

export default HomePage;
